module.exports = __webpack_public_path__ + "static/media/ball.8ea3e56d.jpg";